import { isDryRunProcessLog } from "../../shared/lib/helpers";

export type ProcessLogFilter = "all" | "failed";
export type ProcessLogMessage = Record<string, unknown> & {
  is_dry_run?: boolean;
  message?: string | null;
};

export const getKstDateString = (date = new Date()): string => {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: "Asia/Seoul",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(date);
  const values = Object.fromEntries(parts.map(({ type, value }) => [type, value]));
  return `${values.year}-${values.month}-${values.day}`;
};

export interface VisibleProcessLog {
  message: ProcessLogMessage;
  originalIndex: number;
}

export const isFailedProcessLog = (message: ProcessLogMessage): boolean => (
  message?.category === "item_process_error"
  || (message?.category === "item_process" && message?.is_success === false)
);

export const getVisibleProcessLogs = (
  processLogs: ProcessLogMessage[],
  filter: ProcessLogFilter,
): VisibleProcessLog[] => (
  processLogs
    .map((message, originalIndex) => ({ message, originalIndex }))
    .filter(({ message }) =>
      message.category !== "proxy_health"
      && !isDryRunProcessLog(message)
      && (filter === "all" || isFailedProcessLog(message)),
    )
);
